import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { Observable } from 'rxjs';
import { CreditStatementTableData } from '@dto/creditStatementTableData';

@Injectable({
  providedIn: 'root'
})
export class CreditStatementsService extends EntityService {
  public entityRoute = "credit-statements";

  constructor
  (
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    super(http, baseUrl);
  }

  getCreditStatementsAsTableData(): Observable<CreditStatementTableData[]> {
    return this.http.get<CreditStatementTableData[]>(this.baseUrl + 'api/creditstatements/tabledata');
  }

  downloadCreditStatement(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'api/creditstatements/download/' + id, { responseType: 'blob' as 'json'});
  }
  
  create(userId: string) {
    return this.http.get<number>(this.baseUrl + 'api/creditstatements/create/' + userId);
  }
}
